import { render, staticRenderFns } from "./ChangeModeNote.vue?vue&type=template&id=1912fb50&scoped=true&"
import script from "./ChangeModeNote.vue?vue&type=script&lang=ts&"
export * from "./ChangeModeNote.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeModeNote.vue?vue&type=style&index=0&id=1912fb50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912fb50",
  null
  
)

export default component.exports